var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOracle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.8535 75.8547C20.4904 75.8547 9 64.2992 9 49.8547C9 35.4103 20.4904 23.8547 34.8535 23.8547H65.1465C79.5096 23.8547 91 35.4103 91 49.8547C91 64.2992 79.5096 75.8547 65.1465 75.8547H34.8535ZM64.3631 66.6628C73.7643 66.6628 81.0764 59.0466 81.0764 49.8547C81.0764 40.4002 73.5032 33.0467 64.3631 33.0467H35.6369C26.2357 33.0467 18.9236 40.6628 18.9236 49.8547C18.9236 59.0466 26.4968 66.6628 35.6369 66.6628H64.3631Z",
    fill: "#C74634"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOracle);
export default __webpack_public_path__ + "static/media/oracle.78211df7d6d17e96f79c3ad296cd0103.svg";
export { ForwardRef as ReactComponent };